import React from "react";
import styled from "styled-components";

const Add = styled.img`
  width: 30px;
  margin-right: 16px;
`;

export default (props) => <Add src="/icon-folder.svg" />;
